export const RainfallConstants = {
  CommonLayers: [{
    //   layerNameType: 'STATE',
    //   serviceType: 'VectorLayer',
    //   view: 'Both',
    //   type: 'Time',
    //   env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
    //   dataurl: 'heatWatches/getHeatWatchesData',
    //   hval: 'hwv',
    //   hcat: 'hwc'
    // },
    // {
      layerNameType: 'STATE',
      serviceType: 'WmsLayer',
      view: 'Both',
      type: 'Base',
      env: 'bg_color:#cccccc;bg_opacity:0.7;bg_width:0.5;i_stroke_color:#000000;i_stroke_width:1;i_shadow_color:#000000;i_shadow_opacity=0.1;i_shadow_width:7;o_s_boundary_color:#aaaaaa;o_s_boundary_width:0.5;s_boundary_color:#000000;s_boundary_width:0.1;m_boundary_color:#000000;m_boundary_width:0.5;text_color:#000000;b_s_color:#000000',
      pane: 'state',
      styles: 'INDIA_STATE_NAMES',
      minZoom: 5,
    },],

  PrimarySourceType: 'IMD_SHORT_RANGE',
  SecondarySourceType: 'IMD_LONG_RANGE',

  HeatMapUrl: 'weatherForecast/getHeatMapData/',

  HeatMapOptions: {
    type: 'Time',
    time: '24',
    clip: true,
    view: 'Admin',
    serviceType: 'HeatMap'
  },

  RainFallShortRangeURLConstant: 'RAINFALLSHORTRANGEIMDMAP',
  RainFallLongRangeURLConstant: 'RAINFALLLONGRANGEIMDMAP',

  Legend: {
    colorValues: [
      {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        text: '0'
      },
      {
        backgroundColor: '#C3FDCA',
        color: '#000000',
        text: '0.1'
      },
      {
        backgroundColor: '#01FF04',
        color: '#000000',
        text: '2.5'
      },
      {
        backgroundColor: '#048500',
        color: '#FFFFFF',
        text: '15.6'
      },
      {
        backgroundColor: '#FDC0CB',
        color: '#FFFFFF',
        text: '64.5'
      },
      {
        backgroundColor: '#FC0300',
        color: '#FFFFFF',
        text: '115.6'
      },
      {
        backgroundColor: '#610301',
        color: '#FFFFFF',
        text: '>204.5'
      }
    ],
    Units: 'mm',
  },
  legendData: {
    levels: [
      {
        color: 'transparent',
        name: '0-0.5 (no rainfall)',
      },
      {
        color: '#e6eeff',
        name: '0.5-2.5',
      },
      {
        color: '#80aaff',
        name: '2.5-5',
      },
      {
        color: '#3377ff',
        name: '5-10',
      },
      {
        color: '#003cb3',
        name: '10-20',
      },
      {
        color: '#002266',
        name: '20-30',
      },
      {
        color: '#ff80b3',
        name: '30-40',
      },
      {
        color: '#ff0066',
        name: '40-50',
      },
      {
        color: '#cc0000',
        name: '50-75',
      },
      {
        color: '#660000',
        name: '75-100',
      },
      {
        color: '#ffcccc',
        name: '100-1000',
      }
    ]
  },
  LegendWeekly: {
    colorValues: [
      {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        text: '0'
      },
      {
        backgroundColor: '#fbff99',
        color: '#000000',
        text: '2.4'
      },
      {
        backgroundColor: '#f8ff00',
        color: '#000000',
        text: '15.6'
      },
      {
        backgroundColor: '#2ab0ff',
        color: '#FFFFFF',
        text: '64.5'
      },
      {
        backgroundColor: '#00743c',
        color: '#FFFFFF',
        text: '115.6'
      },
      {
        backgroundColor: '#ff0000',
        color: '#FFFFFF',
        text: '>204.5'
      }
    ],
    Units: 'mm',
  },

  SOURCE_LIST: [
    {
      source: 'ECMWF',
      forecastLengthList: ['24', '10', 'weekly']
    },
    {
      source: 'IMD',
      forecastLengthList: ['24', '10']
    }
  ]
};
